module.exports = __webpack_public_path__ + "components/rewards/ski-line/static/icon-0f159635cfc4cab5e41225a8278e4754.png";